import * as React from 'react';

const DEFAULT_TITLE = 'KeePlaying — Free Music Streaming & Playlists';

export function useDocumentTitle(prefix?: string | null) {
    React.useEffect(() => {
        document.title = prefix ? `${prefix} · KeePlaying` : DEFAULT_TITLE;
    }, [prefix]);
}
